/* eslint-disable */

import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useIsOnline } from 'react-use-is-online';
import { useDispatch } from "react-redux";
import { Tooltip, Avatar, Modal } from "antd";
import { logoutUser } from "../../core/redux/auth.slice";
// import { fetchStores, selectAccessibleStores } from "../../core/redux/store.slice";
// import { getShopIdFromUrl } from "../../utils/routeUtils";
import { useShopRoutes } from "../../hooks/useShopRoutes";
import { navigateToPOS } from "../../utils/appNavigation";
import languageHelper from "../../utils/languageHelper";

/*
// Maps form page segments to their respective list pages.
const FORM_TO_LIST_MAP = {
  'add-sale': 'sales-list',
  'edit-sale': 'sales-list',
  'add-purchase': 'purchase-list',
  'edit-purchase': 'purchase-list',
  'add-customer-order': 'customer-order',
  'edit-customer-order': 'customer-order',
  'add-shop-order': 'shop-order',
  'edit-shop-order': 'shop-order',
  'add-invoice': 'invoice-list',
  'add-quote': 'quote-list',
  'edit-quote': 'quote-list',
  'add-transfer': 'stock-transfer',
  'edit-transfer': 'stock-transfer',
  'edit-inventory': 'inventory',
  'add-product': 'product-list',
  'edit-product': 'product-list',
  'add-employee': 'employees-list',
  'edit-employee': 'employees-list',
};
*/

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  
  // const accessibleStores = useSelector(selectAccessibleStores);
  
  /*
  const [selectedShopId, setSelectedShopId] = useState(() => {
    const shopIdFromUrl = getShopIdFromUrl();
    return shopIdFromUrl || 'all';
  });
  
  React.useEffect(() => {
    const shopId = getShopIdFromUrl();
    setSelectedShopId(shopId);
  }, [location.pathname]);

  React.useEffect(() => {
    if (user) {
      dispatch(fetchStores());
    }
  }, [user, dispatch]);

  const handleShopSelect = (shopId) => {
    const currentPath = location.pathname;
    const pathParts = currentPath.split('/').filter(part => part !== '');

    if (pathParts.length > 0) {
      const pageSegment = pathParts[1];

      if (pageSegment === 'manufacturing-orders' && pathParts[pathParts.length - 1] === 'edit') {
        navigate(`/${shopId}/manufacturing-orders`);
        return;
      }

      const listPage = FORM_TO_LIST_MAP[pageSegment];
      if (listPage) {
        navigate(`/${shopId}/${listPage}`);
      } else {
        pathParts[0] = shopId;
        navigate('/' + pathParts.join('/'));
      }
    } else {
      navigate(`/${shopId}/admin-dashboard`);
    }
  };
  */

  const handleLogout = () => {
    const appWrapper = document.querySelector('.main-wrapper');
    if (appWrapper) appWrapper.classList.add('app-blur');

    Modal.confirm({
      title: t("header.confirmLogout"),
      content: t("header.logoutQuestion"),
      okText: t("header.logout"),
      cancelText: t("common.cancel"),
      centered: true,
      maskClosable: false,
      onOk: async () => {
        try {
          await dispatch(logoutUser()).unwrap();
          navigate('/signin', { replace: true });
        } catch (e) {
          console.warn('[Header ERP] logout error', e);
        } finally {
          if (appWrapper) appWrapper.classList.remove('app-blur');
        }
      },
      onCancel: () => {
        if (appWrapper) appWrapper.classList.remove('app-blur');
      },
    });
  };

  const route = useShopRoutes();
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { t, i18n } = useTranslation();
  
  useEffect(() => {
    if (user?.preferredLang) {
      const lang = user.preferredLang.toLowerCase();
      i18n.changeLanguage(lang);
      localStorage.setItem("language", lang);
    }
  }, [user, i18n]);

  const [flagImage, setFlagImage] = useState(() => {
    return languageHelper.getFlagImage(i18n.language);
  });

  const { isOnline, isOffline } = useIsOnline();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };
  
  /*
  const currentShopName = useMemo(() => {
    const shop = accessibleStores.find((s) => s.shopId === selectedShopId);
    return shop?.shopName || 'Global';
  }, [accessibleStores, selectedShopId]);
  */

  useEffect(() => {
    const lang = i18n.language;
    setFlagImage(languageHelper.getFlagImage(lang));
  }, [i18n.language]);
  
  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();
      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");
      if (body.classList.contains("mini-sidebar") && isElementVisible(toggleBtn)) {
        e.preventDefault();
      }
    };
    document.addEventListener("mouseover", handleMouseover);
    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []);
  
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      document.removeEventListener("msfullscreenchange", handleFullscreenChange);
    };
  }, []);
  
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };
  
  const expandMenus = useSelector((state) => state.themeSetting.expandMenus);
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  
  useEffect(() => {
    document.querySelector(".main-wrapper")?.classList.remove("slide-nav");
    document.querySelector(".sidebar-overlay")?.classList.remove("opened");
    document.querySelector("html")?.classList.remove("menu-opened");
  }, [location.pathname]);

  const [ctime, setTime] = useState(new Date().toLocaleTimeString([], { hour12: false }))
  const [cdate] = useState(
    new Date().toLocaleString('fr-FR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date().toLocaleTimeString([], { hour12: false }))
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  /*
  useEffect(() => {
    if (!user) return;

    if (accessibleStores.length === 1) {
      const onlyShopId = String(accessibleStores[0].shopId);
      setSelectedShopId(onlyShopId);

      const pathParts = location.pathname.split('/').filter(Boolean);

      if (pathParts[0] === 'all') {
        pathParts[0] = onlyShopId;
        navigate('/' + pathParts.join('/'), { replace: true });
      }
    }
  }, [user, accessibleStores, location.pathname, navigate]);
  */

  const onlineStatus = () => {
    if (isOnline) return <span className="d-inline-flex align-items-center p-2 pe-2 rounded-1 text-white bg-success fs-10"> <i className="ti ti-point-filled me-1 fs-11"></i>En ligne</span>
    if (isOffline) return <span className="d-inline-flex align-items-center p-2 pe-2 rounded-1 text-white bg-danger fs-10"> <i className="ti ti-point-filled me-1 fs-11"></i>Hors ligne</span>
    return <></>
  }

  const getUserInitials = React.useCallback((firstName, lastName) => {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  }, []);

  /*
  const availableShops = React.useMemo(() => {
    if (!user) return [];

    const shops = accessibleStores.map(store => ({
      id: String(store.shopId),
      name: store.shopName,
      isCanteen: store.isCanteen === true,
    }));

    if (shops.length === 1) {
      return shops;
    }

    if (user.roles?.includes('ADMIN') && user.roles?.includes('SUPERADMIN')) {
      return [{ id: 'all', name: 'Global' }, ...shops];
    }

    return shops;
  }, [user, accessibleStores]);
  */

  const userPhoto = React.useMemo(() => {
    if (!user?.photos || user.photos.length === 0) return null;
    const principalPhoto = user.photos.find(photo => photo.isPrincipal);
    if (principalPhoto?.presignedUrl) return principalPhoto.presignedUrl;
    const firstPhoto = user.photos.find(photo => photo.presignedUrl);
    return firstPhoto?.presignedUrl || null;
  }, [user]);

  return (
    <>
      <div className="header" style={{ zIndex: 2000 }}>
        <div className="main-header">
          <ul className="nav user-menu">
            <li className="nav-item time-nav">
              <div className="user-time-wrapper d-flex align-items-center">
                <div className="flex-shrink-0 me-1 d-flex align-items-center">
                  {userPhoto ? (
                    <Tooltip title='Profile' placement='bottom'>
                      <Link to={route.profile} >
                        <img
                          src={userPhoto}
                          alt="Img"
                          style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                        />
                      </Link>
                    </Tooltip>
                  ) : (
                    <Tooltip title='Profile' placement='bottom'>
                      <Link to={route.profile} >
                        <Avatar
                          size={40}
                          style={{
                            background: 'var(--primary-gradient)',
                            fontSize: "14px",
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {getUserInitials(user?.firstName, user?.lastName)}
                        </Avatar>
                      </Link>
                    </Tooltip>
                  )}
                </div>

                <div className="flex-grow-1 d-flex flex-column justify-content-center ms-2">
                  <div className="d-flex align-items-center fs-12 mb-1">
                    <i className="ti ti-user" style={{ fontSize: '20px', color: '#1F2E36' }} />
                    <Link to={route.profile} style={{ textDecoration: 'underline' }}>
                      <h6 className="mb-0 me-1">{user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : 'Utilisateur'}</h6>
                    </Link>
                  </div>

                  <div className="d-flex align-items-center fs-12">
                    <i className="ti ti-calendar me-2" style={{ fontSize: '14px', color: '#1F2E36' }} />
                    <h6 className="me-2 mb-0">{cdate}</h6> -
                    <i className="ti ti-clock ms-1 me-1" style={{ fontSize: '14px', color: '#1F2E36' }} />
                    <h6 className="mb-0">{ctime}</h6>
                  </div>
                </div>
              </div>
            </li>

            {!isOnline && (
              <li className="nav-item">
                <span className="bg-danger text-white d-inline-flex align-items-center p-2 pe-2 rounded-1 fs-10">
                  <i className="ti ti-wifi-off me-1 fs-11"></i>Mode hors ligne
                </span>
              </li>
            )}

            <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
              <Link
                to="#"
                className="dropdown-toggle nav-link select-store d-flex align-items-center"
                data-bs-toggle="dropdown"
                style={{ height: '100%' }}
              >
                <span className="user-info d-flex align-items-center">
                  <img
                    src={flagImage}
                    alt="Language"
                    style={{ width: '20px', height: '15px', borderRadius: '2px', marginRight: '8px', objectFit: 'cover' }}
                  />
                  <span className="user-detail">
                    <span className="user-name text-uppercase" style={{ fontSize: '13px', fontWeight: '500' }}>
                      {i18n.language?.substring(0, 2).toUpperCase() || 'FR'}
                    </span>
                  </span>
                </span>
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center ${i18n.language === 'fr' ? 'active-header-item' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeLanguage('fr');
                  }}
                >
                  <img src="/assets/img/flags/fr-flag.jpg" alt="Français" style={{ width: '18px', marginRight: '10px' }} />
                 {t("common.french")}
                </Link>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center ${i18n.language === 'fr' ? 'active-header-item' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeLanguage('en');
                  }}
                >
                  <img src="/assets/img/flags/us-flag.jpg" alt="English" style={{ width: '18px', marginRight: '10px' }} />
                {t("common.english")}
                </Link>
              </div>
            </li>
            
            <li className="nav-item">
              <Tooltip title={t("header.goToPos")} placement='bottom'>
                <Link
                  to="#"
                  onClick={(e) => {
                    navigateToPOS();
                  }}
                  className="btn-header"
                >
                  <i className="ti ti-calculator" />
                  <span>POS</span>
                </Link>
              </Tooltip>
            </li>

            <li className="nav-item">
              <Tooltip title={t("common.logout")} placement='left'>
                <Link
                  to="#"
                  onClick={handleLogout}
                  className="btn-header"
                >
                  <i className="ti ti-logout" />
                  <span>logout </span>
                </Link>
              </Tooltip>
            </li>

          </ul>
          
          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link className="dropdown-item" to="signin" onClick={handleLogout}>
                {t("common.logout")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;